var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78027 10.392L11.6076 3.42967C12.2266 2.94148 13.0746 2.86243 13.7731 3.2278L20.8585 6.93378C21.3921 7.21289 21.7331 7.68264 21.8671 8.20095C21.9509 8.322 22 8.46889 22 8.62726V11.2326C22 12.0451 21.6407 12.8159 21.0186 13.3385L12.7837 20.2548C11.8618 21.0291 10.5433 21.1137 9.53 20.4635L3.26495 16.4437C2.47666 15.9379 2.00001 15.0657 2.00001 14.1291L2 11.6551C2 11.4672 2.06911 11.2954 2.18329 11.1639C2.30913 10.8736 2.50762 10.607 2.78027 10.392ZM12.0099 17.7248L20.5 10.8215V11.2326C20.5 11.6019 20.3367 11.9523 20.0539 12.1898L11.819 19.1062C11.3999 19.4581 10.8006 19.4966 10.34 19.201L4.07499 15.1812C3.71669 14.9513 3.50001 14.5548 3.50001 14.1291L3.50001 13.997L9.6873 17.8685C10.4125 18.3223 11.3461 18.2645 12.0099 17.7248ZM12.1468 5.96216C11.7794 5.77073 11.3265 5.91332 11.135 6.28065C10.9436 6.64797 11.0862 7.10093 11.4535 7.29236L16.3535 9.84596C16.7209 10.0374 17.1738 9.8948 17.3652 9.52747C17.5567 9.16015 17.4141 8.70719 17.0468 8.51576L12.1468 5.96216Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.1bd22476e93b74df3ddd684550715436.svg";
export { ForwardRef as ReactComponent };